.legal-disclaimer {
    display: flex;
    flex-direction: column;
    font-family: var(--ux-font, "Frutiger-Web", sans-serif);
    background: white;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &__content {
        overflow: auto;
        padding: 30px 30px 0;
    }

    &__checkbox {
        input {
            margin-right: 8px;

        }
    }

    &__checkbox__input {
        input {
            margin-right: 8px;
        }
    }

    &__checkbox-label {
        display: inline-block;
        margin-bottom: 0.5rem;
    }

    &__button {
        align-self: center;
        margin-top: 30px;
        margin-bottom: 30px;
    }
}